module.exports = __webpack_public_path__ + "img/img2.805d6e89.svg";